module.exports = __webpack_public_path__ + "static/img/two-piece-2.f5df250.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/two-piece-2.jpg
// module id = 2d6I
// module chunks = 1